import Core from '@/core/module';
import _ from 'lodash';

export default class Addtocart extends Core {
    init() {
    	this.loading = false;
        this.addEventListeners();

        $.ajax({
            url: '/?wc-ajax=get_refreshed_fragments',
            success: (data) => {
                this.refreshContent(data);
            }
        });
    }

    addEventListeners() {
        this.$el.on('click', '[round-that]', (e) => {
            e.preventDefault();

            const $el = $(e.currentTarget);
            const $form = $el.closest('form');
            const $quantity = $form.find('[name="quantity"]');

            const fieldParameters = {
                min: getNumber($quantity.attr('min'), 0),
                max: getNumber($quantity.attr('max'), 0),
                step: getNumber($quantity.attr('step'), 0),
                quantity: getNumber($quantity.val(), 0)
            };

            let roundedValue = getNumber(Math.ceil(fieldParameters.quantity / fieldParameters.step) * fieldParameters.step, 0);

            if(roundedValue < fieldParameters.min) {
                roundedValue = fieldParameters.min;
            }

            $quantity.val(roundedValue).trigger('change');
            $form.find('[name="add-to-cart"]').trigger('click');
        });

        this.$el.on('change', 'select[name^="attribute_"]', (e) => {
            e.preventDefault();
            const $el = $(e.currentTarget);
            const $form = $el.closest('form');
            const $quantity = $form.find('[name="quantity"]');
            const variationProperties = $form.find('[data-product_variations]').data('product_variations');

            const selectedVariationProperties = {};

            _.each($form.find('select[name^="attribute_"]'), (select) => {
                const $el = $(select);

                selectedVariationProperties[$el.attr('name')] = $el.val();
            });

            $('li[combo-error]').remove();

            const founded = _.filter(variationProperties, (item, key) => {
                let success = true;

                _.each(item.attributes, (attribute, attributeKey) => {
                    if(selectedVariationProperties[attributeKey] !== attribute) {
                        success = false;
                    }
                });

                return success;
                // console.log('aa: ', _.difference(item.attributes, selectedVariationProperties));

            });

            if(_.size(founded[0]) == 0) {
                const $errorUl = this.$el.find(`[data-errorgroup~="order"]`).hide();
                $errorUl.find('[data-inputname="order"]').remove();

                $errorUl.append(`<li data-inputname="order" combo-error>Deze combinatie is niet mogelijk</li>`);

                $errorUl.show();
            }
            else {
                $quantity.attr('min', founded[0].min_qty);
                $quantity.attr('max', founded[0].max_qty);
                $quantity.attr('step', founded[0].step);

                $form.find('input[name="variation_id"]').val(founded[0].variation_id);
            }
        });

        $('select[name^="attribute_"]:first').trigger('change');

        this.$el.on('click', '[name="add-to-cart"]', (e) => {
        	e.preventDefault();

        	if(this.loading) {
        	    return;
        	}

        	const $el = $(e.currentTarget);
        	const $form = $el.closest('form');
        	const product_id = $form.data('product-id');
            const $quantity = $form.find('[name="quantity"]');
            const variationProperties = $form.find('[data-product_variations]').data('product_variations');
            let hasErrors = false;

            const selectedVariationProperties = {};

            _.each($form.find('select[name^="attribute_"]'), (select) => {
                const $el = $(select);

                selectedVariationProperties[$el.attr('name')] = $el.val();
            });

            const founded = _.filter(variationProperties, (item, key) => {
                let success = true;

                _.each(item.attributes, (attribute, attributeKey) => {
                    if(selectedVariationProperties[attributeKey] !== attribute) {
                        success = false;
                    }
                });

                return success;
                // console.log('aa: ', _.difference(item.attributes, selectedVariationProperties));

            });

            const fieldParameters = {
                min: getNumber($quantity.attr('min'), 0),
                max: getNumber($quantity.attr('max'), 0),
                step: getNumber($quantity.attr('step'), 0),
                quantity: getNumber($quantity.val(), 0)
            };

            const $errorUl = this.$el.find(`[data-errorgroup~="order"]`).hide();
            $errorUl.find('[data-inputname="order"]').remove();

            if(!founded[0] && _.size(selectedVariationProperties) > 0) {
                $errorUl.append(`<li data-inputname="order">Deze combinatie is niet mogelijk</li>`);
                hasErrors = true;
            }
            else if(fieldParameters.quantity < fieldParameters.min) {
                $errorUl.append(`<li data-inputname="order">De minimale order hoeveelheid is ${fieldParameters.min} stuks<br /><a href="#" class="inline-link" round-that><span>aantal verhogen en bestellen</span> <i class="icon-arrow-right"></i></a></li>`);
                hasErrors = true;
            }

            else if(fieldParameters.quantity > fieldParameters.max && fieldParameters.max != 0 && fieldParameters.max > fieldParameters.min) {
                $errorUl.append(`<li data-inputname="order">De maximale order hoeveelheid is ${fieldParameters.max} stuks</li>`);
                hasErrors = true;
            }

            else if(fieldParameters.quantity / fieldParameters.step != Math.round(fieldParameters.quantity / fieldParameters.step)) {
                $errorUl.append(`<li data-inputname="order">Dit product wordt alleen geleverd per ${fieldParameters.step} stuks <br /><a href="#" class="inline-link" round-that><span>afronden naar boven en bestellen</span> <i class="icon-arrow-right"></i></a></li>`);
                hasErrors = true;
            }

            if(hasErrors) {
                $errorUl.show();
                return;
            }



        	$el.closest('.btn-holder').addClass('loading');

            this.loading = true;

        	$.ajax({
        	    url: '/?wc-ajax=add_variation_to_cart',
        	    data: {
                    product_id: $form.find('[name="product_id"]').val(),
                    variation_id: $form.find('[name="variation_id"]').val(),
                    quantity: $form.find('[name="quantity"]').val()
                },
        	    method: 'post',
        	    success: (data) => {
        	        this.loading = false;

        	        $('.product-popup').addClass('product-popup--show');

        	        if(data.error) {
        	            window.location = data.product_url;
        	        }
        	        else {
        	            this.refreshContent(data);

        	            $el.closest('.btn-holder').removeClass('loading');

        	            const cart_data = $(data.fragments['div.widget_shopping_cart_content']).find('[data-basket]').data('basket');

                        let product = {};

                        if(founded[0] && founded[0]['variation_id']) {
                            product = _.find(cart_data.products, {id: founded[0].variation_id});
                        }
                        else {
                            product = _.find(cart_data.products, {id: product_id});
                        }

                        $quantity.val();

        	            $('.product-popup').find('[single-price]').html(product.price);
        	            $('.product-popup').find('[total-price]').html(cart_data.total_amount);
        	            $('.product-popup').find('[total-products]').html(cart_data.total_count);
        	        }
        	    },
        	    error: () => {
        	        console.log('error');
        	    }
        	});
        });

        this.$el.on('click', '.product-popup [close]', (e) => {
            e.preventDefault();

            const $el = $(e.currentTarget).closest('.product-popup');
            $el.removeClass('product-popup--show');
        });
    }

    refreshContent(data) {
    	$('[mini-cart]').html(data.fragments['div.widget_shopping_cart_content']);
    }
}

function getNumber(number, defaultNumber) {
    return isNaN(parseInt(number, 10)) ? defaultNumber : parseInt(number, 10);
}